(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poo-pourri-ads-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pouri-landing-v2')) {
    customElements.define('pouri-landing-v2', class extends HTMLElement {
      connectedCallback() {
        this.toast = this.querySelector('.pv2__toast');
        this.tierButtons = [...this.querySelectorAll('[data-bundle-tier]')];
        this.bundleOptions = [...this.querySelectorAll('[data-bundle-option]')];
        this.bundleAdd = this.querySelector('[data-bundle-add]');
        this.addEventListener('click', (event) => {
          const tier = event.target.closest('[data-bundle-tier]');
          if (tier) {
            this.selectTier(tier, true);
            return;
          }
          const step = event.target.closest('[data-bundle-step]');
          if (step) {
            this.changeQuantity(step);
            return;
          }
          const bundleButton = event.target.closest('[data-bundle-add]');
          if (bundleButton) {
            this.addBundle(bundleButton);
            return;
          }
          const button = event.target.closest('[data-items]');
          if (!button) return;
          this.addItems(button);
        });
        if (this.tierButtons.length) this.selectTier(this.tierButtons[0]);
      }

      selectTier(button, shouldScroll = false) {
        this.tierButtons.forEach((tier) => {
          const active = tier === button;
          tier.classList.toggle('is-active', active);
          tier.setAttribute('aria-pressed', String(active));
        });
        this.currentTier = {
          home: Number(button.dataset.home),
          travel: Number(button.dataset.travel),
          discount: Number(button.dataset.discount),
          total: Number(button.dataset.total)
        };
        this.bundleOptions.forEach((option) => { option.dataset.quantity = '0'; });
        button.dataset.preset.split(',').forEach((item) => {
          const [variant, quantity] = item.split(':');
          const option = this.bundleOptions.find((candidate) => candidate.dataset.variant === variant);
          if (option) option.dataset.quantity = quantity;
        });
        this.querySelector('[data-travel-group]').hidden = this.currentTier.travel === 0;
        this.updateBundle();
        if (shouldScroll) this.querySelector('.pv2__bundle-builder').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      changeQuantity(button) {
        const option = button.closest('[data-bundle-option]');
        const size = option.dataset.size;
        const direction = Number(button.dataset.bundleStep);
        const current = Number(option.dataset.quantity || 0);
        const selected = this.bundleOptions
          .filter((candidate) => candidate.dataset.size === size)
          .reduce((total, candidate) => total + Number(candidate.dataset.quantity || 0), 0);
        const limit = this.currentTier[size];
        if (direction > 0 && selected >= limit) return;
        option.dataset.quantity = String(Math.max(0, current + direction));
        this.updateBundle();
      }

      updateBundle() {
        let regular = 0;
        const counts = { home: 0, travel: 0 };
        this.bundleOptions.forEach((option) => {
          const quantity = Number(option.dataset.quantity || 0);
          option.querySelector('output').textContent = String(quantity);
          counts[option.dataset.size] += quantity;
          regular += Number(option.dataset.price) * quantity;
        });
        this.querySelector('[data-home-count]').textContent = String(counts.home);
        this.querySelector('[data-home-limit]').textContent = String(this.currentTier.home);
        this.querySelector('[data-travel-count]').textContent = String(counts.travel);
        this.querySelector('[data-travel-limit]').textContent = String(this.currentTier.travel);
        const missing = Math.max(0, this.currentTier.home - counts.home) + Math.max(0, this.currentTier.travel - counts.travel);
        const calculatedSaving = Math.round(regular * this.currentTier.discount) / 100;
        const calculatedTotal = regular - calculatedSaving;
        const total = missing === 0 ? this.currentTier.total : calculatedTotal;
        const saving = missing === 0 ? regular - total : calculatedSaving;
        this.querySelector('[data-bundle-regular]').textContent = this.money(regular);
        this.querySelector('[data-bundle-saving]').textContent = this.money(saving);
        this.querySelector('[data-bundle-total]').textContent = this.money(total);
        this.querySelector('[data-bundle-status]').textContent = missing === 0
          ? this.dataset.bundleReady
          : this.dataset.bundleRemaining.replace('[count]', String(missing));
        this.bundleAdd.disabled = missing !== 0;
      }

      money(value) {
        const locale = this.lang === 'ar' ? 'ar-SA' : 'en-SA';
        return `SAR ${new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)}`;
      }

      addBundle(button) {
        const items = this.bundleOptions
          .map((option) => ({ id: Number(option.dataset.variant), quantity: Number(option.dataset.quantity || 0) }))
          .filter((item) => item.quantity > 0);
        this.addCartItems(button, items);
      }

      async addItems(button) {
        const items = button.dataset.items.split(',').map((item) => {
          const [id, quantity] = item.split(':');
          return { id: Number(id), quantity: Number(quantity) };
        });
        this.addCartItems(button, items);
      }

      async addCartItems(button, items) {
        const original = button.textContent;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          button.textContent = this.dataset.added;
          this.showToast(this.dataset.added);
          window.setTimeout(() => { window.location.href = `${root}cart`; }, 450);
        } catch (error) {
          button.disabled = false;
          button.textContent = original;
          this.showToast(this.dataset.error);
        }
      }

      showToast(message) {
        this.toast.textContent = message;
        this.toast.classList.add('is-visible');
        window.setTimeout(() => this.toast.classList.remove('is-visible'), 2600);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poo-pourri-ads-v3-staging"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pouri-landing-v3-staging')) {
    customElements.define('pouri-landing-v3-staging', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        if (typeof window.HousemartAttribution !== 'function') {
          if (!this.attributionWaitBound) {
            this.attributionWaitBound = true;
            window.addEventListener('housemart:attribution-ready', () => this.connectedCallback(), { once: true });
          }
          return;
        }
        this.dataset.initialized = 'true';
        this.toast = this.querySelector('.pv2__toast');
        this.tierButtons = [...this.querySelectorAll('[data-bundle-tier]')];
        this.bundleOptions = [...this.querySelectorAll('[data-bundle-option]')];
        this.bundleAdd = this.querySelector('[data-bundle-add]');
        this.quickDialog = this.querySelector('[data-quick-dialog]');
        this.offerDialog = this.querySelector('[data-offer-dialog]');
        this.quickAddDefaultText = this.querySelector('[data-quick-add]')?.textContent.trim() || '';
        this.catalog = new Map(
          [...this.querySelectorAll('[data-product-card]')].map((card) => {
            const product = this.catalogProduct(card);
            return [String(product.variant_id), product];
          })
        );
        this.analytics = new window.HousemartAttribution(this);
        this.analytics.publish('housemart:pouri_landing_viewed', {
          section_id: this.dataset.sectionId,
          page_title: document.title
        });
        this.languageClickHandler = (event) => {
          const link = event.target.closest('a[hreflang]');
          if (!link) return;
          this.analytics.publish('housemart:pouri_language_switch', {
            from_language: this.lang,
            to_language: link.getAttribute('hreflang'),
            destination: link.getAttribute('href')
          });
        };
        document.addEventListener('click', this.languageClickHandler);
        this.quickDialog?.addEventListener('close', () => this.quickOpener?.focus());
        this.addEventListener('click', (event) => {
          const quickAdd = event.target.closest('[data-quick-add]');
          if (quickAdd) {
            this.addQuickProduct(quickAdd);
            return;
          }
          const offerAdd = event.target.closest('[data-offer-add-button]');
          if (offerAdd) {
            this.acceptBasketOffer(offerAdd);
            return;
          }
          const offerSkip = event.target.closest('[data-offer-skip]');
          if (offerSkip) {
            this.analytics.publish('housemart:pouri_basket_offer_skipped', this.offerAnalytics());
            return;
          }
          const productLink = event.target.closest('[data-product-card] a[href]');
          if (productLink) {
            const card = productLink.closest('[data-product-card]');
            this.analytics.publish('housemart:pouri_product_detail_viewed', {
              item: this.productCardItem(card),
              destination: productLink.getAttribute('href')
            });
            if (
              this.quickDialog?.showModal &&
              event.button === 0 &&
              !event.metaKey &&
              !event.ctrlKey &&
              !event.shiftKey &&
              !event.altKey
            ) {
              event.preventDefault();
              this.openQuickView(card, productLink);
            }
            return;
          }
          const sizeCard = event.target.closest('.pv2__size-card');
          if (sizeCard) {
            this.analytics.publish('housemart:pouri_size_selected', {
              size: sizeCard.classList.contains('pv2__size-card--home') ? '59 ml' : '30 ml'
            });
            return;
          }
          const sticky = event.target.closest('[data-sticky-cta] a[href]');
          if (sticky) {
            this.analytics.publish('housemart:pouri_sticky_cta_clicked', {
              destination: sticky.getAttribute('href'),
              scroll_percent: this.scrollPercent()
            });
            return;
          }
          const tier = event.target.closest('[data-bundle-tier]');
          if (tier) {
            this.selectTier(tier, true);
            return;
          }
          const step = event.target.closest('[data-bundle-step]');
          if (step) {
            this.changeQuantity(step);
            return;
          }
          const bundleButton = event.target.closest('[data-bundle-add]');
          if (bundleButton) {
            this.addBundle(bundleButton);
            return;
          }
          const button = event.target.closest('[data-items]');
          if (!button) return;
          this.addItems(button);
        });
        this.updateTierCards();
        if (this.tierButtons.length) this.selectTier(this.tierButtons[0]);
      }

      disconnectedCallback() {
        if (this.languageClickHandler) document.removeEventListener('click', this.languageClickHandler);
      }

      scrollPercent() {
        const maximum = document.documentElement.scrollHeight - window.innerHeight;
        if (maximum <= 0) return 100;
        return Math.min(100, Math.round((window.scrollY / maximum) * 100));
      }

      productCardItem(card) {
        const product = this.catalogProduct(card);
        const { id, available, image_url, product_url, notes, ...item } = product;
        return item;
      }

      catalogProduct(card) {
        const button = card.querySelector('[data-items]');
        const variant = button?.dataset.items?.split(',')[0]?.split(':')[0] || null;
        return {
          id: Number(variant),
          item_id: card.dataset.sku,
          variant_id: variant,
          item_name: card.querySelector('h4')?.textContent.trim() || null,
          scent: card.dataset.scent,
          size: card.dataset.size,
          price: Number(card.dataset.priceCents || 0) / 100,
          quantity: 1,
          available: !button?.disabled,
          image_url: card.querySelector('.pv2__product-image img')?.currentSrc || card.querySelector('.pv2__product-image img')?.src || '',
          product_url: card.querySelector('.pv2__details')?.href || card.querySelector('a[href]')?.href || '',
          notes: card.querySelector('.pv2__product-copy > p')?.textContent.trim() || ''
        };
      }

      openQuickView(card, opener) {
        const product = this.catalogProduct(card);
        this.quickProduct = product;
        this.quickOpener = opener;
        const image = this.quickDialog.querySelector('[data-quick-image]');
        image.src = product.image_url;
        image.alt = card.querySelector('.pv2__product-image img')?.alt || product.item_name;
        this.quickDialog.querySelector('[data-quick-size]').textContent = product.size;
        this.quickDialog.querySelector('[data-quick-title]').textContent = product.item_name;
        this.quickDialog.querySelector('[data-quick-notes]').textContent = product.notes;
        this.quickDialog.querySelector('[data-quick-price]').textContent = this.moneyCents(product.price * 100);
        const quickAdd = this.quickDialog.querySelector('[data-quick-add]');
        quickAdd.disabled = !product.available;
        quickAdd.textContent = product.available ? this.quickAddDefaultText : this.dataset.soldOut;
        this.quickDialog.querySelector('[data-quick-full]').href = product.product_url;
        this.quickDialog.showModal();
        quickAdd.focus();
        this.analytics.publish('housemart:pouri_quick_view_opened', {
          item: this.productCardItem(card)
        });
      }

      addQuickProduct(button) {
        const product = this.quickProduct;
        if (!product?.available || button.disabled) return;
        this.quickDialog.close();
        this.addCartItems(button, [{ ...product, quantity: 1 }], {
          type: 'product',
          offerId: 'quick_view_single',
          discountPercent: 0,
          value: product.price
        });
      }

      selectedBundleItems() {
        return this.bundleOptions
          .map((option) => ({
            id: Number(option.dataset.variant),
            item_id: option.dataset.sku,
            variant_id: option.dataset.variant,
            item_name: option.querySelector('h5')?.textContent.trim() || null,
            scent: option.dataset.scent,
            size: option.dataset.size === 'home' ? '59 ml' : '30 ml',
            price: Number(option.dataset.priceCents || 0) / 100,
            quantity: Number(option.dataset.quantity || 0)
          }))
          .filter((item) => item.quantity > 0);
      }

      selectTier(button, shouldScroll = false) {
        this.tierButtons.forEach((tier) => {
          const active = tier === button;
          tier.classList.toggle('is-active', active);
          tier.setAttribute('aria-pressed', String(active));
        });
        this.currentTier = {
          offerId: button.dataset.offerId,
          home: Number(button.dataset.home),
          travel: Number(button.dataset.travel),
          discount: Number(button.dataset.discount)
        };
        this.bundleOptions.forEach((option) => { option.dataset.quantity = '0'; });
        button.dataset.preset.split(',').forEach((item) => {
          const [variant, quantity] = item.split(':');
          const option = this.bundleOptions.find((candidate) => candidate.dataset.variant === variant);
          if (option && option.dataset.available === 'true') option.dataset.quantity = quantity;
        });
        this.querySelector('[data-travel-group]').hidden = this.currentTier.travel === 0;
        this.updateBundle();
        if (shouldScroll) {
          this.analytics.publish('housemart:pouri_bundle_tier_selected', {
            offer_id: this.currentTier.offerId,
            home_count: this.currentTier.home,
            travel_count: this.currentTier.travel,
            discount_percent: this.currentTier.discount,
            value: this.currentBundleTotalCents / 100
          });
          this.querySelector('.pv2__bundle-builder').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      changeQuantity(button) {
        const option = button.closest('[data-bundle-option]');
        if (option.dataset.available !== 'true') return;
        const size = option.dataset.size;
        const direction = Number(button.dataset.bundleStep);
        const current = Number(option.dataset.quantity || 0);
        const selected = this.bundleOptions
          .filter((candidate) => candidate.dataset.size === size)
          .reduce((total, candidate) => total + Number(candidate.dataset.quantity || 0), 0);
        const limit = this.currentTier[size];
        if (direction > 0 && selected >= limit) return;
        option.dataset.quantity = String(Math.max(0, current + direction));
        this.updateBundle();
        this.analytics.publish('housemart:pouri_bundle_quantity_changed', {
          offer_id: this.currentTier.offerId,
          direction,
          item_id: option.dataset.sku,
          variant_id: option.dataset.variant,
          size: option.dataset.size === 'home' ? '59 ml' : '30 ml',
          selected_quantity: Number(option.dataset.quantity)
        });
      }

      updateBundle() {
        let regularCents = 0;
        const counts = { home: 0, travel: 0 };
        this.bundleOptions.forEach((option) => {
          const quantity = Number(option.dataset.quantity || 0);
          option.querySelector('output').textContent = String(quantity);
          counts[option.dataset.size] += quantity;
          regularCents += Number(option.dataset.priceCents || 0) * quantity;
        });
        this.querySelector('[data-home-count]').textContent = String(counts.home);
        this.querySelector('[data-home-limit]').textContent = String(this.currentTier.home);
        this.querySelector('[data-travel-count]').textContent = String(counts.travel);
        this.querySelector('[data-travel-limit]').textContent = String(this.currentTier.travel);
        const missing = Math.max(0, this.currentTier.home - counts.home) + Math.max(0, this.currentTier.travel - counts.travel);
        const savingCents = Math.round(regularCents * this.currentTier.discount / 100);
        const totalCents = regularCents - savingCents;
        this.currentBundleTotalCents = totalCents;
        this.querySelector('[data-bundle-regular]').textContent = this.moneyCents(regularCents);
        this.querySelector('[data-bundle-saving]').textContent = this.moneyCents(savingCents);
        this.querySelector('[data-bundle-total]').textContent = this.moneyCents(totalCents);
        this.querySelector('[data-bundle-status]').textContent = missing === 0
          ? this.dataset.bundleReady
          : this.dataset.bundleRemaining.replace('[count]', String(missing));
        this.bundleAdd.disabled = missing !== 0;
      }

      tierTotals(tier) {
        let regularCents = 0;
        tier.dataset.preset.split(',').forEach((item) => {
          const [variant, quantity] = item.split(':');
          const option = this.bundleOptions.find((candidate) => candidate.dataset.variant === variant);
          regularCents += Number(option?.dataset.priceCents || 0) * Number(quantity || 0);
        });
        const savingCents = Math.round(regularCents * Number(tier.dataset.discount) / 100);
        return { regularCents, totalCents: regularCents - savingCents };
      }

      updateTierCards() {
        this.tierButtons.forEach((tier) => {
          const totals = this.tierTotals(tier);
          tier.querySelector('[data-tier-regular]').textContent = this.moneyCents(totals.regularCents);
          tier.querySelector('[data-tier-total]').textContent = this.moneyCents(totals.totalCents);
        });
      }

      moneyCents(value) {
        const locale = this.lang === 'ar' ? 'ar-SA' : 'en-SA';
        return `SAR ${new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value / 100)}`;
      }

      addBundle(button) {
        const items = this.selectedBundleItems();
        this.addCartItems(button, items, {
          type: 'bundle',
          offerId: this.currentTier.offerId,
          discountPercent: this.currentTier.discount,
          value: this.currentBundleTotalCents / 100
        });
      }

      async addItems(button) {
        if (button.disabled || !button.dataset.items) return;
        const card = button.closest('[data-product-card]');
        const product = this.catalogProduct(card);
        const items = button.dataset.items.split(',').map((item) => {
          const [id, quantity] = item.split(':');
          return { ...product, id: Number(id), variant_id: id, quantity: Number(quantity) };
        });
        this.addCartItems(button, items, {
          type: 'product',
          offerId: 'single_product',
          discountPercent: 0,
          value: items.reduce((total, item) => total + item.price * item.quantity, 0)
        });
      }

      async addCartItems(button, items, context) {
        const original = button.textContent;
        const requestEventId = this.analytics.eventId();
        const analyticsItems = items.map((item) => ({
          item_id: item.item_id,
          variant_id: item.variant_id,
          item_name: item.item_name,
          scent: item.scent,
          size: item.size,
          price: item.price,
          quantity: item.quantity
        }));
        const cartItems = items.map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _hm_lp: this.dataset.pageVersion,
            _hm_offer: context.offerId,
            _hm_event_id: requestEventId
          }
        }));
        button.disabled = true;
        button.textContent = this.dataset.adding;
        this.analytics.publish('housemart:pouri_cart_add_requested', {
          event_id: requestEventId,
          offer_id: context.offerId,
          offer_type: context.type,
          discount_percent: context.discountPercent,
          value: context.value,
          items: analyticsItems
        });
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: cartItems })
          });
          if (!response.ok) throw new Error('Cart request failed');
          const result = await response.json();
          const responseItems = Array.isArray(result?.items) ? result.items : Array.isArray(result) ? result : [result];
          const requestedQuantity = items.reduce((total, item) => total + item.quantity, 0);
          const addedQuantity = responseItems.reduce((total, item) => total + Number(item?.quantity || 0), 0);
          if (addedQuantity < requestedQuantity) {
            this.analytics.publish('housemart:pouri_cart_partial', {
              request_event_id: requestEventId,
              offer_id: context.offerId,
              offer_type: context.type,
              requested_quantity: requestedQuantity,
              added_quantity: addedQuantity,
              items: analyticsItems
            });
            button.textContent = this.dataset.partial;
            this.showToast(this.dataset.partial);
            window.setTimeout(() => { window.location.href = `${root}cart`; }, 1200);
            return;
          }
          this.analytics.publish(context.type === 'bundle' ? 'housemart:pouri_bundle_added' : 'housemart:pouri_product_added', {
            request_event_id: requestEventId,
            offer_id: context.offerId,
            offer_type: context.type,
            discount_percent: context.discountPercent,
            value: context.value,
            items: analyticsItems
          });
          button.textContent = this.dataset.added;
          this.showToast(this.dataset.added);
          if (context.type === 'product') {
            window.setTimeout(() => {
              button.disabled = false;
              button.textContent = original;
              this.showBasketOffer(root, items);
            }, 350);
          } else {
            window.setTimeout(() => { window.location.href = this.dataset.cartUrl || `${root}cart`; }, 650);
          }
        } catch (error) {
          this.analytics.publish('housemart:pouri_cart_error', {
            request_event_id: requestEventId,
            offer_id: context.offerId,
            offer_type: context.type,
            error_type: error instanceof Error ? error.message : 'unknown',
            items: analyticsItems
          });
          button.disabled = false;
          button.textContent = original;
          this.showToast(this.dataset.error);
        }
      }

      sessionOfferWasShown() {
        try {
          return sessionStorage.getItem('hm_pouri_offer_v1') === 'shown';
        } catch (error) {
          return false;
        }
      }

      markSessionOfferShown() {
        try {
          sessionStorage.setItem('hm_pouri_offer_v1', 'shown');
        } catch (error) {
          return;
        }
      }

      productForOffer(size, scent, excludedVariants = []) {
        const products = [...this.catalog.values()].filter((product) => (
          product.available && product.size === size && !excludedVariants.includes(String(product.variant_id))
        ));
        return products.find((product) => product.scent === scent) || products[0] || null;
      }

      async showBasketOffer(root, addedItems) {
        const cartUrl = this.dataset.cartUrl || `${root}cart`;
        if (this.sessionOfferWasShown() || !this.offerDialog?.showModal) {
          window.location.href = cartUrl;
          return;
        }
        try {
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart lookup failed');
          const cart = await response.json();
          const counts = { home: 0, travel: 0 };
          const variantsInCart = [];
          (cart.items || []).forEach((item) => {
            const product = this.catalog.get(String(item.variant_id));
            if (!product) return;
            variantsInCart.push(String(item.variant_id));
            counts[product.size === '59 ml' ? 'home' : 'travel'] += Number(item.quantity || 0);
          });
          const added = addedItems[0];
          let product = null;
          let quantity = 1;
          let message = '';
          let rule = '';
          if (counts.home === 0 && counts.travel > 0) {
            product = this.productForOffer('59 ml', added.scent);
            message = this.dataset.offerTravelOnly;
            rule = 'travel_to_home';
          } else if (counts.home === 1) {
            product = this.productForOffer('59 ml', added.scent);
            quantity = 2;
            message = this.dataset.offerOneHome;
            rule = 'one_to_three_home';
          } else if (counts.home === 2) {
            product = this.productForOffer('59 ml', added.scent, variantsInCart) || this.productForOffer('59 ml', added.scent);
            message = this.dataset.offerTwoHome;
            rule = 'two_to_three_home';
          } else if (counts.home >= 3) {
            product = this.productForOffer('30 ml', added.scent) || this.productForOffer('30 ml', 'original_citrus');
            message = this.dataset.offerThreeHome;
            rule = 'home_to_travel';
          }
          if (!product) {
            window.location.href = cartUrl;
            return;
          }
          this.markSessionOfferShown();
          this.currentOffer = { product, quantity, rule, cart };
          const image = this.offerDialog.querySelector('[data-offer-image]');
          image.src = product.image_url;
          image.alt = product.item_name;
          this.offerDialog.querySelector('[data-offer-message]').textContent = message;
          this.offerDialog.querySelector('[data-offer-product]').textContent = quantity > 1 ? `${quantity} × ${product.item_name}` : product.item_name;
          this.offerDialog.querySelector('[data-offer-price]').textContent = this.moneyCents(product.price * quantity * 100);
          const addButton = this.offerDialog.querySelector('[data-offer-add-button]');
          addButton.textContent = `${this.dataset.offerAdd} — ${this.moneyCents(product.price * quantity * 100)}`;
          addButton.disabled = false;
          this.offerDialog.querySelector('[data-offer-skip]').href = cartUrl;
          this.offerDialog.showModal();
          addButton.focus();
          this.analytics.publish('housemart:pouri_basket_offer_shown', this.offerAnalytics());
        } catch (error) {
          window.location.href = cartUrl;
        }
      }

      offerAnalytics() {
        const offer = this.currentOffer;
        if (!offer) return {};
        return {
          offer_rule: offer.rule,
          item: {
            item_id: offer.product.item_id,
            variant_id: offer.product.variant_id,
            item_name: offer.product.item_name,
            scent: offer.product.scent,
            size: offer.product.size,
            price: offer.product.price,
            quantity: offer.quantity
          },
          basket_value_before: Number(offer.cart?.total_price || 0) / 100,
          basket_items_before: Number(offer.cart?.item_count || 0)
        };
      }

      async acceptBasketOffer(button) {
        const offer = this.currentOffer;
        if (!offer || button.disabled) return;
        const original = button.textContent;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{
              id: offer.product.id,
              quantity: offer.quantity,
              properties: { _hm_lp: this.dataset.pageVersion, _hm_offer: offer.rule }
            }] })
          });
          if (!response.ok) throw new Error('Offer add failed');
          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          this.analytics.publish('housemart:pouri_basket_offer_accepted', {
            ...this.offerAnalytics(),
            basket_value_after: Number(cart?.total_price || 0) / 100,
            basket_items_after: Number(cart?.item_count || 0)
          });
          window.location.href = this.dataset.cartUrl || `${root}cart`;
        } catch (error) {
          button.disabled = false;
          button.textContent = original;
          this.showToast(this.dataset.error);
        }
      }

      showToast(message) {
        this.toast.textContent = message;
        this.toast.classList.add('is-visible');
        window.setTimeout(() => this.toast.classList.remove('is-visible'), 2600);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poo-pourri-ads-v4-staging"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pouri-landing-v4-staging')) {
    customElements.define('pouri-landing-v4-staging', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.analytics = {
          eventId: () => window.crypto?.randomUUID?.() || `hm-${Date.now()}-${Math.random().toString(16).slice(2)}`,
          publish: () => null
        };
        this.toast = this.querySelector('.pv2__toast');
        this.cartNotice = this.querySelector('[data-cart-notice]');
        this.tierButtons = [...this.querySelectorAll('[data-bundle-tier]')];
        this.bundleOptions = [...this.querySelectorAll('[data-bundle-option]')];
        this.bundleAdd = this.querySelector('[data-bundle-add]');
        this.quickDialog = this.querySelector('[data-quick-dialog]');
        this.offerDialog = this.querySelector('[data-offer-dialog]');
        this.quickAddDefaultText = this.querySelector('[data-quick-add]')?.textContent.trim() || '';
        this.querySelectorAll('[data-product-card]').forEach((card) => {
          if (card.dataset.mappingValid === 'true') return;
          const button = card.querySelector('[data-items]');
          if (!button) return;
          button.disabled = true;
          button.textContent = this.dataset.mappingError;
        });
        this.catalog = new Map(
          [...this.querySelectorAll('[data-product-card]')].map((card) => {
            const product = this.catalogProduct(card);
            return [String(product.variant_id), product];
          })
        );
        this.activateAnalytics();
        if (!this.analyticsActive) {
          this.analyticsReadyHandler = () => this.activateAnalytics();
          window.addEventListener('housemart:attribution-ready', this.analyticsReadyHandler, { once: true });
        }
        this.bindVideoMeasurement();
        this.bindReviewMeasurement();
        this.bindStickyCTA();
        this.languageClickHandler = (event) => {
          const link = event.target.closest('a[hreflang]');
          if (!link) return;
          this.analytics.publish('housemart:pouri_language_switch', {
            from_language: this.lang,
            to_language: link.getAttribute('hreflang'),
            destination: link.getAttribute('href')
          });
        };
        document.addEventListener('click', this.languageClickHandler);
        this.quickDialog?.addEventListener('close', () => {
          if (this.quickProduct) {
            this.analytics.publish('housemart:pouri_quick_view_closed', {
              item_id: this.quickProduct.item_id,
              variant_id: this.quickProduct.variant_id
            });
          }
          this.quickOpener?.focus();
        });
        this.addEventListener('click', (event) => {
          const quickAdd = event.target.closest('[data-quick-add]');
          if (quickAdd) {
            this.addQuickProduct(quickAdd);
            return;
          }
          const offerAdd = event.target.closest('[data-offer-add-button]');
          if (offerAdd) {
            this.acceptBasketOffer(offerAdd);
            return;
          }
          const offerSkip = event.target.closest('[data-offer-skip]');
          if (offerSkip) {
            this.analytics.publish('housemart:pouri_basket_offer_skipped', this.offerAnalytics());
            return;
          }
          const noticeClose = event.target.closest('[data-cart-notice-close]');
          if (noticeClose) {
            this.hideCartNotice();
            return;
          }
          const fullProduct = event.target.closest('[data-quick-full]');
          if (fullProduct) {
            this.analytics.publish('housemart:pouri_full_product_opened', {
              item_id: this.quickProduct?.item_id || null,
              variant_id: this.quickProduct?.variant_id || null,
              destination: fullProduct.getAttribute('href')
            });
            return;
          }
          const productLink = event.target.closest('[data-product-card] a[href]');
          if (productLink) {
            const card = productLink.closest('[data-product-card]');
            this.analytics.publish('housemart:pouri_product_detail_viewed', {
              item: this.productCardItem(card),
              destination: productLink.getAttribute('href')
            });
            if (
              this.quickDialog?.showModal &&
              event.button === 0 &&
              !event.metaKey &&
              !event.ctrlKey &&
              !event.shiftKey &&
              !event.altKey
            ) {
              event.preventDefault();
              this.openQuickView(card, productLink);
            }
            return;
          }
          const sizeCard = event.target.closest('.pv2__size-card');
          if (sizeCard) {
            this.analytics.publish('housemart:pouri_size_selected', {
              size: sizeCard.classList.contains('pv2__size-card--home') ? '59 ml' : '30 ml'
            });
            return;
          }
          const sticky = event.target.closest('[data-sticky-cta] a[href]');
          if (sticky) {
            this.analytics.publish('housemart:pouri_sticky_cta_clicked', {
              destination: sticky.getAttribute('href'),
              scroll_percent: this.scrollPercent()
            });
            return;
          }
          const tier = event.target.closest('[data-bundle-tier]');
          if (tier) {
            this.selectTier(tier, true);
            return;
          }
          const step = event.target.closest('[data-bundle-step]');
          if (step) {
            this.changeQuantity(step);
            return;
          }
          const bundleButton = event.target.closest('[data-bundle-add]');
          if (bundleButton) {
            this.addBundle(bundleButton);
            return;
          }
          const button = event.target.closest('[data-items]');
          if (!button) return;
          this.addItems(button);
        });
        this.updateTierCards();
        if (this.tierButtons.length) this.selectTier(this.tierButtons[0]);
      }

      disconnectedCallback() {
        if (this.languageClickHandler) document.removeEventListener('click', this.languageClickHandler);
        if (this.analyticsReadyHandler) window.removeEventListener('housemart:attribution-ready', this.analyticsReadyHandler);
        this.reviewObserver?.disconnect();
        this.heroObserver?.disconnect();
        this.videoObserver?.disconnect();
      }

      activateAnalytics() {
        if (this.analyticsActive || typeof window.HousemartAttribution !== 'function') return;
        this.analytics = new window.HousemartAttribution(this);
        this.analyticsActive = true;
        this.analytics.publish('housemart:pouri_landing_viewed', {
          section_id: this.dataset.sectionId,
          page_title: document.title
        });
      }

      bindStickyCTA() {
        const heroPrimary = this.querySelector('[data-hero-primary]');
        const howSection = this.querySelector('#pv2-how');
        const sticky = this.querySelector('[data-sticky-cta]');
        if (!heroPrimary || !sticky || !('IntersectionObserver' in window)) return;
        const visibleSections = new Map();
        const updateSticky = () => {
          sticky.classList.toggle('is-visible', ![...visibleSections.values()].some(Boolean));
        };
        this.heroObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => visibleSections.set(entry.target, entry.isIntersecting));
          updateSticky();
        }, { threshold: 0.15 });
        this.heroObserver.observe(heroPrimary);
        if (howSection) this.heroObserver.observe(howSection);
      }

      bindVideoMeasurement() {
        const video = this.querySelector('[data-demo-video]');
        if (!video) return;
        const stage = this.querySelector('[data-video-stage]');
        const playButton = this.querySelector('[data-video-play]');
        video.muted = true;
        video.defaultMuted = true;
        if (video.dataset.mobilePoster && video.dataset.desktopPoster) {
          const media = window.matchMedia('(max-width: 749px)');
          const updatePoster = () => {
            const nextPoster = media.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
            if (video.getAttribute('poster') !== nextPoster) video.setAttribute('poster', nextPoster);
          };
          updatePoster();
          media.addEventListener?.('change', updatePoster);
        }
        const updateVideoState = () => {
          const isPlaying = !video.paused && !video.ended;
          stage?.classList.toggle('is-playing', isPlaying);
          if (playButton) playButton.hidden = isPlaying;
        };
        playButton?.addEventListener('click', async () => {
          try {
            await video.play();
          } catch (error) {
            playButton.hidden = false;
          }
          updateVideoState();
        });
        video.addEventListener('play', updateVideoState);
        video.addEventListener('pause', updateVideoState);
        video.addEventListener('ended', updateVideoState);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = navigator.connection?.saveData === true;
        if (!reduceMotion && !saveData && 'IntersectionObserver' in window) {
          let userPaused = false;
          video.addEventListener('pause', () => {
            if (video.dataset.autoPause !== 'true' && video.currentTime > 0 && !video.ended) userPaused = true;
            delete video.dataset.autoPause;
          });
          video.addEventListener('play', () => { userPaused = false; });
          this.videoObserver = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && !userPaused) {
              video.play().catch(() => updateVideoState());
              return;
            }
            if (!entry.isIntersecting && !video.paused) {
              video.dataset.autoPause = 'true';
              video.pause();
            }
          }, { threshold: 0.58 });
          this.videoObserver.observe(video);
        }
        updateVideoState();
        const milestones = [25, 50, 75];
        const publishedMilestones = new Set();
        let completionPublished = false;
        const publishCompletion = () => {
          if (completionPublished) return;
          completionPublished = true;
          this.analytics.publish('housemart:pouri_video_completed', {
            video_id: 'landing_demo',
            percent: 100
          });
        };
        video.addEventListener('play', () => {
          this.analytics.publish('housemart:pouri_video_started', {
            video_id: 'landing_demo',
            duration_seconds: Number.isFinite(video.duration) ? Math.round(video.duration) : null
          });
        }, { once: true });
        video.addEventListener('timeupdate', () => {
          if (!Number.isFinite(video.duration) || video.duration <= 0) return;
          const percent = Math.floor(video.currentTime / video.duration * 100);
          milestones.forEach((milestone) => {
            if (percent < milestone || publishedMilestones.has(milestone)) return;
            publishedMilestones.add(milestone);
            this.analytics.publish('housemart:pouri_video_progress', {
              video_id: 'landing_demo',
              percent: milestone
            });
          });
          if (percent >= 95) publishCompletion();
        });
        video.addEventListener('ended', publishCompletion);
      }

      bindReviewMeasurement() {
        const module = this.querySelector('[data-review-module]');
        if (!module || !('IntersectionObserver' in window)) return;
        this.reviewObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.analytics.publish('housemart:pouri_review_module_viewed', {
            review_count: Number(module.dataset.reviewCount || 0)
          });
          this.reviewObserver.disconnect();
        }, { threshold: 0.35 });
        this.reviewObserver.observe(module);
      }

      scrollPercent() {
        const maximum = document.documentElement.scrollHeight - window.innerHeight;
        if (maximum <= 0) return 100;
        return Math.min(100, Math.round((window.scrollY / maximum) * 100));
      }

      productCardItem(card) {
        const product = this.catalogProduct(card);
        const { id, available, image_url, product_url, notes, ...item } = product;
        return item;
      }

      catalogProduct(card) {
        const button = card.querySelector('[data-items]');
        const variant = button?.dataset.items?.split(',')[0]?.split(':')[0] || null;
        return {
          id: Number(variant),
          item_id: card.dataset.sku,
          variant_id: variant,
          item_name: card.querySelector('h4')?.textContent.trim() || null,
          scent: card.dataset.scent,
          size: card.dataset.size,
          price: Number(card.dataset.priceCents || 0) / 100,
          quantity: 1,
          available: card.dataset.mappingValid === 'true' && !button?.disabled,
          image_url: card.querySelector('.pv2__product-image img')?.currentSrc || card.querySelector('.pv2__product-image img')?.src || '',
          product_url: card.querySelector('.pv2__details')?.href || card.querySelector('a[href]')?.href || '',
          notes: card.querySelector('.pv2__product-copy > p')?.textContent.trim() || ''
        };
      }

      openQuickView(card, opener) {
        const product = this.catalogProduct(card);
        this.quickProduct = product;
        this.quickOpener = opener;
        const image = this.quickDialog.querySelector('[data-quick-image]');
        image.src = product.image_url;
        image.alt = card.querySelector('.pv2__product-image img')?.alt || product.item_name;
        this.quickDialog.querySelector('[data-quick-size]').textContent = product.size;
        this.quickDialog.querySelector('[data-quick-title]').textContent = product.item_name;
        this.quickDialog.querySelector('[data-quick-notes]').textContent = product.notes;
        this.quickDialog.querySelector('[data-quick-price]').textContent = this.moneyCents(product.price * 100);
        const quickAdd = this.quickDialog.querySelector('[data-quick-add]');
        quickAdd.disabled = !product.available;
        quickAdd.textContent = product.available ? this.quickAddDefaultText : this.dataset.soldOut;
        this.quickDialog.querySelector('[data-quick-full]').href = product.product_url;
        this.quickDialog.showModal();
        quickAdd.focus();
        this.analytics.publish('housemart:pouri_quick_view_opened', {
          item: this.productCardItem(card)
        });
      }

      addQuickProduct(button) {
        const product = this.quickProduct;
        if (!product?.available || button.disabled) return;
        this.analytics.publish('housemart:pouri_quick_view_added', {
          item: {
            item_id: product.item_id,
            variant_id: product.variant_id,
            item_name: product.item_name,
            scent: product.scent,
            size: product.size,
            price: product.price,
            quantity: 1
          }
        });
        this.quickDialog.close();
        this.addCartItems(button, [{ ...product, quantity: 1 }], {
          type: 'product',
          offerId: 'quick_view_single',
          discountPercent: 0,
          value: product.price
        });
      }

      selectedBundleItems() {
        return this.bundleOptions
          .map((option) => ({
            id: Number(option.dataset.variant),
            item_id: option.dataset.sku,
            variant_id: option.dataset.variant,
            item_name: option.querySelector('h5')?.textContent.trim() || null,
            scent: option.dataset.scent,
            size: option.dataset.size === 'home' ? '59 ml' : '30 ml',
            price: Number(option.dataset.priceCents || 0) / 100,
            quantity: Number(option.dataset.quantity || 0)
          }))
          .filter((item) => item.quantity > 0);
      }

      selectTier(button, shouldScroll = false) {
        this.tierButtons.forEach((tier) => {
          const active = tier === button;
          tier.classList.toggle('is-active', active);
          tier.setAttribute('aria-pressed', String(active));
        });
        this.currentTier = {
          offerId: button.dataset.offerId,
          home: Number(button.dataset.home),
          travel: Number(button.dataset.travel),
          discount: Number(button.dataset.discount)
        };
        this.bundleOptions.forEach((option) => { option.dataset.quantity = '0'; });
        button.dataset.preset.split(',').forEach((item) => {
          const [variant, quantity] = item.split(':');
          const option = this.bundleOptions.find((candidate) => candidate.dataset.variant === variant);
          if (option && option.dataset.available === 'true') option.dataset.quantity = quantity;
        });
        this.querySelector('[data-travel-group]').hidden = this.currentTier.travel === 0;
        this.updateBundle();
        if (shouldScroll) {
          this.analytics.publish('housemart:pouri_bundle_tier_selected', {
            offer_id: this.currentTier.offerId,
            home_count: this.currentTier.home,
            travel_count: this.currentTier.travel,
            discount_percent: this.currentTier.discount,
            value: this.currentBundleTotalCents / 100
          });
          this.querySelector('.pv2__bundle-builder').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      changeQuantity(button) {
        const option = button.closest('[data-bundle-option]');
        if (option.dataset.available !== 'true') return;
        const size = option.dataset.size;
        const direction = Number(button.dataset.bundleStep);
        const current = Number(option.dataset.quantity || 0);
        const selected = this.bundleOptions
          .filter((candidate) => candidate.dataset.size === size)
          .reduce((total, candidate) => total + Number(candidate.dataset.quantity || 0), 0);
        const limit = this.currentTier[size];
        if (direction > 0 && selected >= limit) return;
        option.dataset.quantity = String(Math.max(0, current + direction));
        this.updateBundle();
        this.analytics.publish('housemart:pouri_bundle_quantity_changed', {
          offer_id: this.currentTier.offerId,
          direction,
          item_id: option.dataset.sku,
          variant_id: option.dataset.variant,
          size: option.dataset.size === 'home' ? '59 ml' : '30 ml',
          selected_quantity: Number(option.dataset.quantity)
        });
      }

      updateBundle() {
        let regularCents = 0;
        let totalCents = 0;
        const counts = { home: 0, travel: 0 };
        this.bundleOptions.forEach((option) => {
          const quantity = Number(option.dataset.quantity || 0);
          option.querySelector('output').textContent = String(quantity);
          counts[option.dataset.size] += quantity;
          const lineTotals = this.bundleLineTotals(option, quantity, this.currentTier.discount);
          regularCents += lineTotals.regularCents;
          totalCents += lineTotals.totalCents;
        });
        this.querySelector('[data-home-count]').textContent = String(counts.home);
        this.querySelector('[data-home-limit]').textContent = String(this.currentTier.home);
        this.querySelector('[data-travel-count]').textContent = String(counts.travel);
        this.querySelector('[data-travel-limit]').textContent = String(this.currentTier.travel);
        const missing = Math.max(0, this.currentTier.home - counts.home) + Math.max(0, this.currentTier.travel - counts.travel);
        const savingCents = regularCents - totalCents;
        this.currentBundleTotalCents = totalCents;
        this.querySelector('[data-bundle-regular]').textContent = this.moneyCents(regularCents);
        this.querySelector('[data-bundle-saving]').textContent = this.moneyCents(savingCents);
        this.querySelector('[data-bundle-total]').textContent = this.moneyCents(totalCents);
        this.querySelector('[data-bundle-status]').textContent = missing === 0
          ? this.dataset.bundleReady
          : this.dataset.bundleRemaining.replace('[count]', String(missing));
        this.bundleAdd.disabled = missing !== 0;
      }

      tierTotals(tier) {
        let regularCents = 0;
        let totalCents = 0;
        tier.dataset.preset.split(',').forEach((item) => {
          const [variant, quantity] = item.split(':');
          const option = this.bundleOptions.find((candidate) => candidate.dataset.variant === variant);
          const lineTotals = this.bundleLineTotals(option, Number(quantity || 0), Number(tier.dataset.discount));
          regularCents += lineTotals.regularCents;
          totalCents += lineTotals.totalCents;
        });
        return { regularCents, totalCents };
      }

      bundleLineTotals(option, quantity, discountPercent) {
        if (!option || quantity <= 0) return { regularCents: 0, totalCents: 0 };
        const basePriceCents = Number(option.dataset.basePriceCents || 0);
        const unitDiscountCents = Math.floor(basePriceCents * discountPercent / 100);
        return {
          regularCents: Math.round(basePriceCents * quantity * 1.15),
          totalCents: Math.round((basePriceCents - unitDiscountCents) * quantity * 1.15)
        };
      }

      updateTierCards() {
        this.tierButtons.forEach((tier) => {
          const totals = this.tierTotals(tier);
          tier.querySelector('[data-tier-regular]').textContent = this.moneyCents(totals.regularCents);
          tier.querySelector('[data-tier-total]').textContent = this.moneyCents(totals.totalCents);
        });
      }

      moneyCents(value) {
        const locale = this.lang === 'ar' ? 'ar-SA' : 'en-SA';
        return `SAR ${new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value / 100)}`;
      }

      addBundle(button) {
        const items = this.selectedBundleItems();
        this.addCartItems(button, items, {
          type: 'bundle',
          offerId: this.currentTier.offerId,
          discountPercent: this.currentTier.discount,
          value: this.currentBundleTotalCents / 100
        });
      }

      async addItems(button) {
        if (button.disabled || !button.dataset.items) return;
        const card = button.closest('[data-product-card]');
        const product = this.catalogProduct(card);
        if (!product.available) {
          this.showToast(this.dataset.mappingError);
          return;
        }
        const items = button.dataset.items.split(',').map((item) => {
          const [id, quantity] = item.split(':');
          return { ...product, id: Number(id), variant_id: id, quantity: Number(quantity) };
        });
        this.addCartItems(button, items, {
          type: 'product',
          offerId: 'single_product',
          discountPercent: 0,
          value: items.reduce((total, item) => total + item.price * item.quantity, 0)
        });
      }

      async addCartItems(button, items, context) {
        const original = button.textContent;
        const requestEventId = this.analytics.eventId();
        const analyticsItems = items.map((item) => ({
          item_id: item.item_id,
          variant_id: item.variant_id,
          item_name: item.item_name,
          scent: item.scent,
          size: item.size,
          price: item.price,
          quantity: item.quantity
        }));
        const cartItems = items.map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            _hm_lp: this.dataset.pageVersion,
            _hm_offer: context.offerId,
            _hm_event_id: requestEventId,
            _hm_experiment: this.dataset.experimentId,
            _hm_variant: this.dataset.experimentVariant
          }
        }));
        button.disabled = true;
        button.textContent = this.dataset.adding;
        this.analytics.publish('housemart:pouri_cart_add_requested', {
          event_id: requestEventId,
          offer_id: context.offerId,
          offer_type: context.type,
          discount_percent: context.discountPercent,
          value: context.value,
          items: analyticsItems
        });
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: cartItems })
          });
          if (!response.ok) throw new Error('Cart request failed');
          const result = await response.json();
          const responseItems = Array.isArray(result?.items) ? result.items : Array.isArray(result) ? result : [result];
          const requestedQuantity = items.reduce((total, item) => total + item.quantity, 0);
          const addedQuantity = responseItems.reduce((total, item) => total + Number(item?.quantity || 0), 0);
          if (addedQuantity < requestedQuantity) {
            this.analytics.publish('housemart:pouri_cart_partial', {
              request_event_id: requestEventId,
              offer_id: context.offerId,
              offer_type: context.type,
              requested_quantity: requestedQuantity,
              added_quantity: addedQuantity,
              items: analyticsItems
            });
            button.textContent = this.dataset.partial;
            this.showToast(this.dataset.partial);
            this.showCartNotice(this.dataset.partial);
            window.setTimeout(() => {
              button.disabled = false;
              button.textContent = original;
            }, 1600);
            return;
          }
          this.analytics.publish(context.type === 'bundle' ? 'housemart:pouri_bundle_added' : 'housemart:pouri_product_added', {
            request_event_id: requestEventId,
            offer_id: context.offerId,
            offer_type: context.type,
            discount_percent: context.discountPercent,
            value: context.value,
            items: analyticsItems
          });
          button.textContent = this.dataset.added;
          this.showToast(this.dataset.added);
          this.showCartNotice(this.dataset.added);
          window.setTimeout(() => {
            button.disabled = false;
            button.textContent = original;
            this.showBasketOffer(root, items);
          }, 350);
        } catch (error) {
          this.analytics.publish('housemart:pouri_cart_error', {
            request_event_id: requestEventId,
            offer_id: context.offerId,
            offer_type: context.type,
            error_type: error instanceof Error ? error.message : 'unknown',
            items: analyticsItems
          });
          button.disabled = false;
          button.textContent = original;
          this.showToast(this.dataset.error);
        }
      }

      sessionOfferWasShown() {
        try {
          return sessionStorage.getItem('hm_pouri_offer_v4') === 'shown';
        } catch (error) {
          return false;
        }
      }

      markSessionOfferShown() {
        try {
          sessionStorage.setItem('hm_pouri_offer_v4', 'shown');
        } catch (error) {
          return;
        }
      }

      productForOffer(size, scent, excludedVariants = []) {
        const products = [...this.catalog.values()].filter((product) => (
          product.available && product.size === size && !excludedVariants.includes(String(product.variant_id))
        ));
        return products.find((product) => product.scent === scent) || products[0] || null;
      }

      async showBasketOffer(root, addedItems) {
        const cartUrl = this.dataset.cartUrl || `${root}cart`;
        if (this.sessionOfferWasShown() || !this.offerDialog?.showModal) {
          return;
        }
        try {
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart lookup failed');
          const cart = await response.json();
          const counts = { home: 0, travel: 0 };
          const variantsInCart = [];
          (cart.items || []).forEach((item) => {
            const product = this.catalog.get(String(item.variant_id));
            if (!product) return;
            variantsInCart.push(String(item.variant_id));
            counts[product.size === '59 ml' ? 'home' : 'travel'] += Number(item.quantity || 0);
          });
          const added = addedItems[0];
          let product = null;
          let quantity = 1;
          let message = '';
          let rule = '';
          if (counts.home === 0 && counts.travel > 0) {
            product = this.productForOffer('59 ml', added.scent);
            message = this.dataset.offerTravelOnly;
            rule = 'travel_to_home';
          } else if (counts.home === 1) {
            product = this.productForOffer('59 ml', added.scent);
            quantity = 2;
            message = this.dataset.offerOneHome;
            rule = 'one_to_three_home';
          } else if (counts.home === 2) {
            product = this.productForOffer('59 ml', added.scent, variantsInCart) || this.productForOffer('59 ml', added.scent);
            message = this.dataset.offerTwoHome;
            rule = 'two_to_three_home';
          } else if (counts.home >= 3) {
            product = this.productForOffer('30 ml', added.scent) || this.productForOffer('30 ml', 'original_citrus');
            message = this.dataset.offerThreeHome;
            rule = 'home_to_travel';
          }
          if (!product) {
            return;
          }
          this.markSessionOfferShown();
          this.currentOffer = { product, quantity, rule, cart };
          const image = this.offerDialog.querySelector('[data-offer-image]');
          image.src = product.image_url;
          image.alt = product.item_name;
          this.offerDialog.querySelector('[data-offer-message]').textContent = message;
          this.offerDialog.querySelector('[data-offer-product]').textContent = quantity > 1 ? `${quantity} × ${product.item_name}` : product.item_name;
          this.offerDialog.querySelector('[data-offer-price]').textContent = this.moneyCents(product.price * quantity * 100);
          const addButton = this.offerDialog.querySelector('[data-offer-add-button]');
          addButton.textContent = `${this.dataset.offerAdd} — ${this.moneyCents(product.price * quantity * 100)}`;
          addButton.disabled = false;
          this.offerDialog.querySelector('[data-offer-skip]').href = cartUrl;
          this.offerDialog.showModal();
          addButton.focus();
          this.analytics.publish('housemart:pouri_basket_offer_shown', this.offerAnalytics());
        } catch (error) {
          return;
        }
      }

      offerAnalytics() {
        const offer = this.currentOffer;
        if (!offer) return {};
        return {
          offer_rule: offer.rule,
          item: {
            item_id: offer.product.item_id,
            variant_id: offer.product.variant_id,
            item_name: offer.product.item_name,
            scent: offer.product.scent,
            size: offer.product.size,
            price: offer.product.price,
            quantity: offer.quantity
          },
          basket_value_before: Number(offer.cart?.total_price || 0) / 100,
          basket_items_before: Number(offer.cart?.item_count || 0)
        };
      }

      async acceptBasketOffer(button) {
        const offer = this.currentOffer;
        if (!offer || button.disabled) return;
        const original = button.textContent;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{
              id: offer.product.id,
              quantity: offer.quantity,
              properties: {
                _hm_lp: this.dataset.pageVersion,
                _hm_offer: offer.rule,
                _hm_experiment: this.dataset.experimentId,
                _hm_variant: this.dataset.experimentVariant
              }
            }] })
          });
          if (!response.ok) throw new Error('Offer add failed');
          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          const cart = cartResponse.ok ? await cartResponse.json() : null;
          this.analytics.publish('housemart:pouri_basket_offer_accepted', {
            ...this.offerAnalytics(),
            basket_value_after: Number(cart?.total_price || 0) / 100,
            basket_items_after: Number(cart?.item_count || 0)
          });
          window.location.href = this.dataset.cartUrl || `${root}cart`;
        } catch (error) {
          button.disabled = false;
          button.textContent = original;
          this.showToast(this.dataset.error);
        }
      }

      showToast(message) {
        this.toast.textContent = message;
        this.toast.classList.add('is-visible');
        window.setTimeout(() => this.toast.classList.remove('is-visible'), 2600);
      }

      showCartNotice(message) {
        if (!this.cartNotice) return;
        const messageNode = this.cartNotice.querySelector('[data-cart-notice-message]');
        if (messageNode) messageNode.textContent = message;
        this.cartNotice.hidden = false;
      }

      hideCartNotice() {
        if (this.cartNotice) this.cartNotice.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
